import { Component, OnInit, } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ReleaseNotesService } from '../../services/master';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WhatsDeleteModalComponent } from '../whats-delete-modal/whats-delete-modal.component'; 
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from 'src/app/services/common/has-permission.service';

@Component({
  standalone: false,
  selector: 'app-whats-new-edit',
  templateUrl: './whats-new-edit.component.html',
  styleUrls: ['./whats-new-edit.component.scss']
})
export class WhatsNewEditComponent implements OnInit {
  releaseNoteForm: FormGroup;
  releaseNotesID: number;
  today = new Date().toISOString().split('T')[0];

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private releseNoteService: ReleaseNotesService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private permission: HasPermissionService,
  ) {}

  ngOnInit(): void {
    this.initForm();

    this.route.queryParams.subscribe(params => {
      const encoded = params['data'];
      if (!encoded) {
        this.router.navigate(['/whats-new-list']);
        return;
      }

      try {
        const decoded = decodeURIComponent(escape(atob(encoded)));
        const parsedData = JSON.parse(decoded);
        this.populateForm(parsedData);
      } catch (err) {
        this.router.navigate(['/whats-new-list']);
      }
    });
  }

  initForm(): void {
    this.releaseNoteForm = this.fb.group({
      releaseNoteLabel: ['', Validators.required],
      initialDate: ['', Validators.required],
      endDate: ['', Validators.required],
      isActive: [true],
      releaseNotes: this.fb.array([])
    });
  }

  get releaseNotes(): FormArray {
    return this.releaseNoteForm.get('releaseNotes') as FormArray;
  }

  addNoteField(value: string = '') {
    this.releaseNotes.push(this.fb.control(value, Validators.required));
  }

  removeNoteField(index: number) {
    this.releaseNotes.removeAt(index);
  }

  populateForm(data: any): void {
    this.releaseNotesID = data.releaseNotesID;

    const formattedInitialDate = this.convertToISO(data.initialDate);
    const formattedEndDate = data.endDate?.split('T')[0] || '';

    this.releaseNoteForm.patchValue({
      releaseNoteLabel: data.releaseNoteLabel,
      initialDate: formattedInitialDate,
      endDate: formattedEndDate,
      isActive: data.isActive
    });

    const notesArray = Array.isArray(data.releaseNote) ? data.releaseNote : [];

    if (notesArray.length > 0) {
      notesArray.forEach((note: string) => this.addNoteField(note));
    } else {
      this.addNoteField();
    }
  }

  convertToISO(dateStr: string): string {
    const parsed = new Date(dateStr);
    if (isNaN(parsed.getTime())) return '';
    return parsed.toISOString().split('T')[0];
  }

  back(): void {
    this.router.navigate(['/whats-new-list']);
  }

  save(): void {
    if (this.releaseNoteForm.invalid) return;

    const formValue = this.releaseNoteForm.value;

    const payload = {
      releaseNotesID: this.releaseNotesID,
      releaseNoteLabel: formValue.releaseNoteLabel,
      initialDate: formValue.initialDate,
      endDate: formValue.endDate,
      isActive: formValue.isActive,
      releaseNote: JSON.stringify({ ReleaseNotes: formValue.releaseNotes })
    };


    this.releseNoteService.apiReleaseNotesUpdateReleaseNotesPost(payload).subscribe({
      next: () => {
        this.toastr.success(this.translate.instant('Action.Success'));
        this.router.navigate(['/whats-new-list']);
      },
      error: () => {
        this.toastr.error(this.translate.instant('Action.Error'));
      }
    });

  }
  openDeleteModal(): void {
    const modalRef = this.modalService.open(WhatsDeleteModalComponent);
    modalRef.componentInstance.releaseNotesID = this.releaseNotesID;
  
    modalRef.result.then((confirmed) => {
      if (confirmed) {
        this.releseNoteService.apiReleaseNotesDeleteReleaseNotesIdDelete(this.releaseNotesID).subscribe({
          next: () => {
            this.toastr.success(this.translate.instant('Action.Success'));
            this.router.navigate(['/whats-new-list']);
          },
          error: () => {
            this.toastr.error(this.translate.instant('Action.Error'));
          }
        });
      }
    }).catch(() => {
    });
  }
}
